import React, { useEffect, useState } from 'react';
import { categoryService } from '../../services/api';
import { Box, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';

const CategorySubcategorySelect = ({
  value = { categoryId: '', subcategoryId: '' },
  onChange = () => {},
  lang = 'it',
  disabled = false,
  allowedPairs = null,
  compact = false,
}) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await categoryService.list(lang);
        setCategories(res.data);
      } catch (e) { /* noop */ }
      setLoading(false);
    };
    load();
  }, [lang]);

  const filteredCategories = allowedPairs
    ? categories.filter(c => Object.prototype.hasOwnProperty.call(allowedPairs, String(c.id)) || Object.prototype.hasOwnProperty.call(allowedPairs, c.id))
    : categories;
  const currentCat = filteredCategories.find(c => String(c.id) === String(value.categoryId));
  const handleCategoryChange = (cid) => {
    onChange({ categoryId: cid, subcategoryId: '' });
  };
  const handleSubcategoryChange = (sid) => {
    onChange({ categoryId: value.categoryId, subcategoryId: sid });
  };

return (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      flexWrap: { xs: 'nowrap', sm: 'wrap', md: 'nowrap' },
      gap: 2,
      width: '100%',
      minWidth: 0,
    }}
  >
    <FormControl
      sx={{
        width: '100%',
        minWidth: { sm: compact ? 200 : 240 },
        flex: { sm: 1, md: compact ? 0 : 1 },
      }}
      disabled={disabled || loading}
    >
      <InputLabel id="cat-label">Categoria</InputLabel>
      <Select
        labelId="cat-label"
        label="Categoria"
        value={value.categoryId}
        onChange={(e) => handleCategoryChange(e.target.value)}
      >
        <MenuItem value=""><em>Seleziona</em></MenuItem>
        {filteredCategories.map(c => (
          <MenuItem key={c.id} value={String(c.id)}>
            {c.label || c.label_it || c.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl
      sx={{
        width: '100%',
        minWidth: { sm: compact ? 240 : 280 },
        flex: { sm: 1, md: compact ? 0 : 1 },
      }}
      disabled={disabled || loading || !currentCat}
    >
      <InputLabel id="sub-label">Sottocategoria</InputLabel>
      <Select
        labelId="sub-label"
        label="Sottocategoria"
        value={value.subcategoryId}
        onChange={(e) => handleSubcategoryChange(e.target.value)}
      >
        <MenuItem value=""><em>Seleziona</em></MenuItem>
        {(() => {
          const subs = currentCat?.subcategories || [];
          if (allowedPairs && currentCat) {
            const allowed = allowedPairs[String(currentCat.id)] || allowedPairs[currentCat.id] || [];
            return subs.filter(s => allowed.length === 0 ? true : allowed.includes(String(s.id)) || allowed.includes(s.id));
          }
          return subs;
        })().map(s => (
          <MenuItem key={s.id} value={String(s.id)}>
            {s.label || s.label_it || s.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {loading && <CircularProgress size={24} />}
  </Box>
);

};

export default CategorySubcategorySelect;
